var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureRigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.802,
    height: 44.361,
    viewBox: "0 0 34.802 44.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_578",
    "data-name": "Grupo 578",
    transform: "translate(-1902.198 -816)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22298",
    "data-name": "Trazado 22298",
    d: "M1922.312,818v5.063h-4.088l-.243,1.721-4.656,33.035a.557.557,0,0,1-.62.542.564.564,0,0,1-.63-.563l-3.538-32.949-.192-1.786H1904.2V818h18.114m2-2H1902.2v9.063h4.35l3.538,32.949a2.63,2.63,0,0,0,5.22.086l4.655-33.035h4.351V816Z",
    fill: "#a6d66b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22299",
    "data-name": "Trazado 22299",
    d: "M1919.543,828.988l1.143.062v-1.088H1931.2v-.725h5.8v7.613h-6.163V833.4h-3.988v6.163h-1.813V833.4h-4.35v-1.45h-1.459",
    fill: "#a6d66b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureRigth);
export default __webpack_public_path__ + "static/media/figure-rigth.708c4e762242c422893fcc3efb137987.svg";
export { ForwardRef as ReactComponent };